import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import PatientsCreateAndEdit from "Components/Patients/PatientsCreateAndEdit";
import PatientsMain from "Components/Patients/PatientsMain";
import ImportCsvMain from "Components/ImportCsv/ImportCsvMain";
// const PatientsMain = React.lazy(() =>
//   import("Components/Patients/PatientsMain")
// );
// const PatientsCreateAndEdit = React.lazy(() =>
//   import("Components/Patients/PatientsCreateAndEdit")
// );
// const ImportCsvMain = React.lazy(() =>
//   import("Components/ImportCsv/ImportCsvMain")
// );

const Patients = () => {
  const query = new URLSearchParams(window.location.search);

  return (
    <>
      {"import-patient".includes(query.get("actionType")) ? (
        <ImportCsvMain />
      ) : (
        <>
          {["create", "edit"].includes(query.get("actionType")) ? (
            <PatientsCreateAndEdit />
          ) : (
            <PatientsMain />
          )}{" "}
        </>
      )}
    </>
  );
};

export default Patients;
